import {
  call, put, all, takeLatest,
} from 'redux-saga/effects';
import { authRequest } from '../../helpers/request.helper';
import {
  constants_proveedores,
} from '../actions/constants/proveedores.constants';

function* obtenerProveedores() {
  const formData = new FormData();
  formData.append('limite', '-1');
  formData.append('orden', JSON.stringify({ strNombre: 'ASC' }));
  const params = {
    url: 'api/proveedores/buscar',
    method: 'POST',
    body: formData,
  };

  try {
    const {
      datos: proveedores,
    } = yield call(authRequest, params);
    yield put({ type: constants_proveedores.OBTENER_PROVEEDORES_SUCCESS, payload: proveedores });
  } catch (error) {
    yield put({ type: constants_proveedores.OBTENER_PROVEEDORES_FAILURE, payload: error });
  }
}
function* obtenerProveedoresOpto11() {
  const formData = new FormData();
  const params = {
    url: 'api/proveedores/opto11/buscar',
    method: 'POST',
    body: formData,
  };

  try {
    const datos = yield call(authRequest, params);
    yield put({ type: constants_proveedores.OBTENER_PROVEEDORES_OPTO11_SUCCESS, payload: datos });
  } catch (error) {
    yield put({ type: constants_proveedores.OBTENER_PROVEEDORES_OPTO11_FAILURE, payload: error });
  }
}


function* proveedoresSaga() {
  yield takeLatest(constants_proveedores.OBTENER_PROVEEDORES_REQUEST, obtenerProveedores);
  yield takeLatest(constants_proveedores.OBTENER_PROVEEDORES_OPTO11_REQUEST, obtenerProveedoresOpto11);
}

export default proveedoresSaga;
